module.exports = __webpack_public_path__ + "static/media/usecase.d454efbb.png";